import type { DraftJson } from '@apps/card/routes/CardCustomizer/DraftJson.types';

/**
 * The standalone-envelope discriminator: an envelope and no card front. Mirrors card_service's
 * `isEnvelopeOnlyCard`.
 *
 * `!card.front?.layers`, not `...?.length` — card_service tolerates a stray `front: {}` but counts
 * `front: { layers: [] }` as a card, and the two must not disagree.
 *
 * Its own module, with a type-only import, so it stays a leaf: `isValidStationeryDraft` is imported
 * by the admin dashboard, and routing this through `isEnvelopeOrder` would give those modules a
 * runtime edge into the card customizer for a predicate that needs none of it.
 */
export const isEnvelopeOnlyBlob = (blob: unknown): boolean => {
  const card = (blob as DraftJson | null | undefined)?.card;
  return !!card?.envelope && !card.front?.layers;
};
